exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-son[data-v-9ad040a8]{padding:20px;margin-top:20px;border:4px solid #1890ff}.action[data-v-9ad040a8]{margin-right:5px}", ""]);

// exports
